module.exports = __webpack_public_path__ + "static/img/plat.14d6decf.png";